export var getApplicationStatusMessage = function getApplicationStatusMessage(status, paidAt) {
  if (status.canceled) {
    return 'Cancelled';
  }
  if (status.rejected) {
    return 'Rejected';
  }
  if (status.withdrawn) {
    return 'Withdrawn';
  }
  if (status.refundInProgress) {
    return 'Refund in Progress';
  }
  if (status.deferralInProgress) {
    return 'Deferral in Progress';
  }
  if (status.enrollmentConfirmed) {
    return 'Enrollment Confirmed';
  }
  if (status.readyToEnroll) {
    return 'Ready to Enroll';
  }
  if (status.readyForVisa) {
    return 'Ready for Visa';
  }
  if (status.accepted) {
    return 'Accepted';
  }
  if (status.waitlisted) {
    return 'Waitlisted';
  }
  if (status.programClosed) {
    return 'Program Closed';
  }
  if (status.submitted) {
    return 'Submitted';
  }
  if (status.readyToSubmit) {
    return 'Ready to Submit';
  }
  if (paidAt) {
    return 'Reviewing';
  }
  return 'Unpaid';
};